// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__SG7EM","menuItem":"Navbar_menuItem__Nrpt9","menuItemHover":"Navbar_menuItemHover__3BkIm"};